<template>
  <h2 class="mb-6 mb-lg-10" :class="[textClass ? textClass : 'secondary--text']" style="line-height: 120%">
    {{ label }}
  </h2>
</template>

<script>
export default {
  props: {
    label: { type: String, required: true },
    textClass: { type: String, required: false }
  }
}
</script>
